import Vue from 'vue'
import App from './App'
import router from './router'
import { apolloProvider } from './apollo'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  provide: apolloProvider.provide()
})



// WEBPACK FOOTER //
// ./src/main.js